// Levelled logger. Debug output is dropped in production builds.
/* biome-ignore-all lint/suspicious/noConsole: this is the one place allowed to use the console */
import { env } from '@/config/env';

type Level = 'debug' | 'info' | 'warn' | 'error';

function log(level: Level, message: string, data?: unknown) {
  if (level === 'debug' && env.isProduction) return;
  const line = `[dentlog] ${message}`;
  const args = data === undefined ? [line] : [line, data];
  if (level === 'error') console.error(...args);
  else if (level === 'warn') console.warn(...args);
  else if (level === 'info') console.info(...args);
  else console.debug(...args);
}

export const logger = {
  debug: (m: string, d?: unknown) => log('debug', m, d),
  info: (m: string, d?: unknown) => log('info', m, d),
  warn: (m: string, d?: unknown) => log('warn', m, d),
  error: (m: string, d?: unknown) => log('error', m, d),
};
